var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 113,
    viewBox: "0 0 120 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0208 110.462H1V1.04001H79.3732",
    stroke: "#1D1D1B",
    strokeWidth: 1.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0605 110.462H119V1.04001H99.8406",
    stroke: "#1D1D1B",
    strokeWidth: 1.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.686 107.251C36.686 109.976 34.4807 112.19 31.7473 112.19C29.0222 112.19 26.8086 109.984 26.8086 107.251C26.8086 104.526 31.7473 96.0907 31.7473 96.0907C31.7473 96.0907 36.686 104.526 36.686 107.251Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3171 18.447L85.5445 3.18655C87.2717 0.847174 90.5418 0.293764 92.8141 1.97073C95.0864 3.63932 95.5392 6.92619 93.8119 9.27395L82.5846 24.5344",
    stroke: "#1D1D1B",
    strokeWidth: 1.2495,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0752 24.2493L84.7646 26.9576L79.8762 33.5984L66.4604 23.7294L71.3488 17.0886L78.3166 22.2118",
    stroke: "#1D1D1B",
    strokeWidth: 1.2495,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6481 31.7285L45.163 74.5164C42.832 77.6859 40.7442 78.3232 38.279 80.1846C35.8139 82.046 33.4493 85.727 31.9736 84.6453C30.4979 83.5637 33.3068 80.2098 34.3549 77.3002C35.403 74.3907 34.8832 72.8898 37.7172 69.0411L69.2024 26.2532",
    stroke: "#1D1D1B",
    strokeWidth: 1.2495,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropper);
export default __webpack_public_path__ + "static/media/dropper.61325b53.svg";
export { ForwardRef as ReactComponent };